import { AxiosResponse } from 'axios';

export function getResponseHeader(response: AxiosResponse | Response, name:string) {
  return response.headers instanceof Headers ? response.headers.get(name) : response.headers[name];
}
